import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { HeaderMenuProps } from './types/HeaderTypes';

export const HeaderMenu: React.FC<HeaderMenuProps> = ({
  isOpen,
  onClose,
  onProfile,
  onLogout,
  menuId,
  isMobile,
  ...menuProps
}) => {
  const handleProfile = () => {
    onProfile();
    onClose();
  };

  const handleLogout = () => {
    onLogout();
    onClose();
  };

  return (
    <Menu
      id={menuId}
      keepMounted
      open={isOpen}
      onClose={onClose}
      {...menuProps}
    >
      <MenuItem onClick={handleProfile}>Profilis</MenuItem>
      <MenuItem onClick={handleLogout}>Atsijungti</MenuItem>
    </Menu>
  );
}; 